var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card dashboard__card--no-min" },
    [
      _vm.loading ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loading }
        },
        [_vm._m(0), _vm._v(" "), _c("Accounts")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard__card-header" }, [
      _c("div", { staticClass: "dashboard__card-title" }, [_vm._v("Accounts")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "dashboard__card-title-icon dashboard__card-title-icon--library"
        },
        [
          _c("span", {
            staticClass: "glyphicon glyphicon-list-alt",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }